<template>
    <ul class="transfer-trips">
        <Trip v-for="trip in trips" :key="trip.id" :tripId="trip.id" />
    </ul>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { TransferTrip } from '@/helpers/transfer/transfer.interfaces';
    import Trip from './Trip/Trip.vue';

    export default defineComponent({
        name: 'TransferTrip',
        methods: { t },
        components: { Trip },
        props: {
            trips: { type: Array as PropType<TransferTrip[]>, required: true },
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Trips.scss';
</style>
